// AI 创建活动标记提取/剥离。
// 后端在创建成功的那轮回复末尾注入 [[activity_id:<id>]] [[activity_key:<key>]]，
// 前端负责提取并从展示文本中删除。
// 只接受完整双右括号结尾（负向前瞻），避免把 ]]] 之类普通文本误判为活动编号。
// 与小程序侧 utils/aiActivityMarker.js 保持同一正则与语义。
const AI_ACTIVITY_MARKER_PATTERN =
  /\[\[activity_id[=:：]\s*([^\]\r\n]+?)\s*\]\](?!\])/i;
const AI_ACTIVITY_KEY_MARKER_PATTERN =
  /\[\[activity_key[=:：]\s*([^\]\r\n]+?)\s*\]\](?!\])/i;
const AI_ANY_ACTIVITY_MARKER_GLOBAL_PATTERN =
  /\s*\[\[activity_(?:id|key)[=:：]\s*[^\]\r\n]+?\s*\]\](?!\])\s*/gi;

export function extractAiActivityId(text) {
  const match = String(text || "").match(AI_ACTIVITY_MARKER_PATTERN);
  const activityId = match ? match[1].trim() : "";
  return activityId || null;
}

export function extractAiActivityKey(text) {
  const match = String(text || "").match(AI_ACTIVITY_KEY_MARKER_PATTERN);
  const activityKey = match ? match[1].trim() : "";
  return activityKey || null;
}

export function stripAiActivityMarkers(text) {
  return String(text || "")
    .replace(AI_ANY_ACTIVITY_MARKER_GLOBAL_PATTERN, "")
    .trim();
}
